import useAppSelector from "./useAppSelector";

const useUserRights = () => {
  const user = useAppSelector((state) => {
    return state.oidc?.user;
  });
  const me = useAppSelector((state) => {
    return state.oidc?.me;
  });
  const apiUrl = useAppSelector((state) => {
    return state.app.apiUrl;
  });
  const organization = useAppSelector((state) => {
    return state.app.organization;
  });
  const membership = me?.organizations.find((item) => {
    return (
      item.organization.slug === organization?.slug && item.status === "active"
    );
  });

  return {
    canManageIcons: Boolean(user && organization?.slug && apiUrl),
    canManageUsers: Boolean(
      membership?.role === "admin" &&
        membership.organization.plan_source !== "sso" &&
        ["business", "pro"].includes(membership.organization.plan),
    ),
  };
};

export default useUserRights;
